/* eslint-disable comma-dangle */
import Head from 'next/head'
// Helpers
import parse from 'html-react-parser'
// Types
import type {Ballot} from '../types/ballot'

interface ClientHeadProps {
  ballot?: Ballot
}

const ClientHead = ({ballot}: ClientHeadProps) => {
  const ballotGeneral = ballot?.general
  const headInjection = ballotGeneral?.custom_header

  const customGoogleAnalyticsTrackingId = ballotGeneral?.google_analytics?.tracking_id
  const analyticsTrackingIdIsCustom = Boolean(customGoogleAnalyticsTrackingId) && (customGoogleAnalyticsTrackingId !== 'G-BQ2HQZ6KQ7')

  return <Head>
    {/* <!-- Google Analytics --> */}
    <script async src="https://www.googletagmanager.com/gtag/js?id=G-BQ2HQZ6KQ7"></script>
    <script
      dangerouslySetInnerHTML={{
        __html: `window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-BQ2HQZ6KQ7');
          ${analyticsTrackingIdIsCustom ? 'gtag(\'config\', \'' + customGoogleAnalyticsTrackingId + '\');' : ''}`
      }}
    />

    {headInjection &&
      // TODO: Add the favicon to ballotMeta AND the admin UI
      // Unfortunately, this won't remove the need for a custom head injection
      // But it will reduce it's workload (since 90% of headInjection is favicon)
      parse(headInjection)
    }
  </Head>
}

export default ClientHead
